import * as React from 'react';

import { SeoFullListHidden } from './SeoFullListHidden';
import { SeoLinksList } from './SeoLinksList';
import { SeoTabs } from './SeoTabs';
import * as style from './style.css';
import { getDefaultTab } from './utils/getDefaultTab';
import { ISeoLinksTab } from '../../../common/types/seoTabsLinks';

interface ITabsLinksProps {
  tabs: ISeoLinksTab[];
}

export const SeoTabsLinks = ({ tabs }: ITabsLinksProps) => {
  const [selectedTab, setSelectedTab] = React.useState(getDefaultTab(tabs));

  const onTabChange = React.useCallback((_: React.ChangeEvent<HTMLInputElement>, value: number) => {
    setSelectedTab(value);
  }, []);

  const links = React.useMemo(() => tabs[selectedTab].links, [tabs, selectedTab]);

  return (
    <div className={style['container']}>
      <SeoTabs tabs={tabs} value={selectedTab} onChange={onTabChange} />
      <SeoLinksList links={links} />
      <SeoFullListHidden tabs={tabs} />
    </div>
  );
};
